export default __webpack_public_path__ + "static/media/front-sample.35b6b701.svg";